// src/utils/coordinateUtils.js
import proj4 from "proj4";

// === Define Supported Projections ===

// Irish ITM (EPSG:2157)
proj4.defs(
  "EPSG:2157",
  "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=0.999820 " +
    "+x_0=600000 +y_0=750000 +ellps=GRS80 " +
    "+towgs84=0,0,0,0,0,0,0 +units=m +no_defs"
);

// British National Grid (EPSG:27700)
proj4.defs(
  "EPSG:27700",
  "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 " +
    "+x_0=400000 +y_0=-100000 +ellps=airy " +
    "+datum=OSGB36 +units=m +no_defs"
);

// Web Mercator (EPSG:3857) – used in USA maps, not for precision
proj4.defs(
  "EPSG:3857",
  "+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 " + "+datum=WGS84 +units=m +no_defs"
);

// === Optional: UI-friendly labels for settings dropdowns ===
export const supportedProjections = [
  { code: "WGS84", label: "WGS84 (Lat/Lng)" }, // EPSG:4326
  { code: "2157", label: "Irish ITM (EPSG:2157)" },
  { code: "27700", label: "UK National Grid (EPSG:27700)" },
  { code: "3857", label: "Web Mercator (EPSG:3857)" },
];

// === Coordinate Converter ===
export function convertCoords(lat, lng, from = "WGS84", to = "WGS84") {
  if (from === to || lat == null || lng == null) return { x: lng, y: lat };

  const fromProj = from === "WGS84" ? "EPSG:4326" : `EPSG:${from}`;
  const toProj = to === "WGS84" ? "EPSG:4326" : `EPSG:${to}`;

  const [x, y] = proj4(fromProj, toProj, [lng, lat]); // Proj4 expects [x, y] = [lng, lat]
  return { x, y };
}
